import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import closeIcon from '../static/img/SelectGame/iconCloseButton.svg';
import styles from '../static/styles/DailyCheckin.module.css';
import RewardClaimPopup from '../components/RewardClaimPopup';
import WelcomeImage from '../static/img/DailyCheckin/imageWelcome.avif';
import WelcomeBackImage from '../static/img/DailyCheckin/imageWelcomeBack.avif';
import { claimDailyReward, getActiveDayData, updateActiveDayData } from '../api/auth';
import { trackDailyCheckin } from '../utils/analytics';
import creditIcon from "../static/img/Home/creditIcon.avif";

import tickIcon from '../static/img/DailyCheckin/iconTick.svg';
import lockIcon from '../static/img/DailyCheckin/iconLock.svg';

import taskHeaderIcon from '../static/img/DailyCheckin/iconTaskHeader.svg';

import dayClaimedIcon from '../static/img/DailyCheckin/iconDayClaimed.svg';
import dayCurrentIcon from '../static/img/DailyCheckin/iconDayCurrent.svg';
import DayItem from '../components/DayItem';

const DailyCheckin = ({ isOpen, onClose }) => {
  const [activeDay, setActiveDay] = useState(null);
  const [rewardClaimed, setRewardClaimed] = useState(false);
  const [showRewardPopup, setShowRewardPopup] = useState(false);
  const activeDayData = JSON.parse(sessionStorage.getItem('activeDayData'));

  useEffect(() => {
    // const storedActiveDay = sessionStorage.getItem('activeDay');
    // const storedRewardClaimed = sessionStorage.getItem('rewardClaimed');

    // if (storedActiveDay) {
    //   setActiveDay(JSON.parse(storedActiveDay));
    //   console.log('Active day:', JSON.parse(storedActiveDay));
    // }

    // if (storedRewardClaimed) {
    //   setRewardClaimed(JSON.parse(storedRewardClaimed));
    // }
  }, []);


  useEffect(() => {
    // const storedActiveDay = sessionStorage.getItem('activeDay');
    // const storedRewardClaimed = sessionStorage.getItem('rewardClaimed');

    // if (storedActiveDay) {
    //   setActiveDay(JSON.parse(storedActiveDay));
    //   console.log('Active day:', JSON.parse(storedActiveDay));
    // }

    // if (storedRewardClaimed) {
    //   setRewardClaimed(JSON.parse(storedRewardClaimed));
    // }
  }, [isOpen]);

  const daysPerPage = 8;
  const pagesToShow = 3;

  // Calculate current set index based on activeDay from sessionStorage..
  const currentSetIndex = activeDay ? Math.floor((activeDay - 1) / daysPerPage) : 0;
  const startSetIndex = Math.max(0, currentSetIndex - 1); // avoid -ve nmbr

  const visibleStartDays = Array.from({ length: pagesToShow }, (_, i) =>
    (startSetIndex + i) * daysPerPage + 1
  );

  const handleClaimReward = async () => {
    try {
      if (activeDayData) {
        const response = await updateActiveDayData();
        if (response.success) {
          trackDailyCheckin(activeDayData.streak_to_claim, activeDayData.amount_to_claim);

          setShowRewardPopup(true);
          trackDailyCheckin(activeDayData.streak_to_claim, activeDayData.amount_to_claim);
        } else {
          setRewardClaimed(true);
          sessionStorage.setItem('rewardClaimed', 'true');
        }
        const newActiveDayData = await getActiveDayData();
        if (newActiveDayData) {
          sessionStorage.setItem("activeDayData", JSON.stringify(newActiveDayData));
          sessionStorage.setItem('activeDay', newActiveDayData.active_streak);
          sessionStorage.setItem('gameId', newActiveDayData.gameId);
        }
      }
    } catch (error) {
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleCloseRewardPopup = () => {
    setShowRewardPopup(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.dailyCheckinContainer}>
      <img
        src={closeIcon}
        alt="Close"
        className={styles.closeButton}
        onClick={handleClose}
      />

      <div className={styles.rewardssubHeader}>
        <p>🔥 Streaks - Day {activeDayData.streak_to_claim} of 30</p>
      </div>

      <div className={styles.rewardsHeader}>
        <spam className={styles.checkinTitle}>WELCOME</spam>
        <spam className={styles.checkinTitle2}>BACK</spam>
      </div>
      <p className={styles.welcomeMsg}>Keep coming back for more Credits and Rewards every day</p>

      <div className={styles.streakWrapper}>

        {(activeDayData.streak_to_claim - 2) > 0 && (
          <div className={`${styles.dayCard} ${styles.completedCard}`}>
            <p className={styles.dayText}>DAY</p>

            <h2 className={styles.dayNumber}>
              {activeDayData.streak_to_claim - 2}
            </h2>

            <div className={styles.iconCircle}>
              <span className={styles.tick}>✓</span>
            </div>
          </div>
        )}

        {(activeDayData.streak_to_claim - 1) > 0 && (
          <div className={`${styles.dayCard} ${styles.completedCard}`}>
            <p className={styles.dayText}>DAY</p>

            <h2 className={styles.dayNumber}>
              {activeDayData.streak_to_claim - 1}
            </h2>

            <div className={styles.iconCircle}>
              <span className={styles.tick}>✓</span>
            </div>
          </div>
        )}

        <div className={`${styles.dayCard} ${styles.activeCard}`}>
          <p className={styles.dayText}>DAY</p>

          <h2 className={styles.dayNumber}>
            {activeDayData.streak_to_claim}
          </h2>

          <div className={styles.iconCircle}>
            <div className={styles.coin}><img src={creditIcon} alt="" /></div>
          </div>
        </div>

        {(activeDayData.streak_to_claim + 1) <= 30 && (
          <div className={`${styles.dayCard} ${styles.dayText}`}>
            <p className={styles.dayText}>DAY</p>

            <h2 className={styles.dayNumber}>
              {activeDayData.streak_to_claim + 1}
            </h2>

            <div className={styles.iconCircle}>
              <div className={styles.coin}></div>
            </div>
          </div>
        )}

        {(activeDayData.streak_to_claim + 2) <= 30 && (
          <div className={`${styles.dayCard} ${styles.dayText}`}>
            <p className={styles.dayText}>DAY</p>

            <h2 className={styles.dayNumber}>
              {activeDayData.streak_to_claim + 2}
            </h2>

            <div className={styles.iconCircle}>
              <div className={styles.coin}></div>
            </div>
          </div>
        )}

      </div>

      <div className={styles.rewardBanner}>
        <div className={styles.rewardIconBox}>
          🎁
        </div>
        <div className={styles.rewardContent}>
          <p className={styles.rewardTitle}>
            TODAY'S REWARD
          </p>
          <h2 className={styles.rewardAmount}>
            {activeDayData.amount_to_claim ?? (15 + ((activeDayData.streak_to_claim - 1) * 5))} Credits
          </h2>
        </div>

      </div>

      <div
        className={styles.claimBtnHeader}
        onClick={handleClaimReward}
      >
        <button
          className={styles.claimBtn}
          disabled={activeDayData.rewardClaimed}
        >
          <span>
            {activeDayData.rewardClaimed
              ? "Already Claimed"
              : `Claim Day ${activeDayData.streak_to_claim} Streak`}
          </span>
        </button>
      </div>




      <RewardClaimPopup
        isOpen={showRewardPopup}
        onClose={() => { handleCloseRewardPopup() }}
        credits={activeDayData.amount_to_claim}
      />

    </div>
  );
};

export default DailyCheckin;